
import { defineComponent } from 'vue';
import { ISignageList } from '../../store/interfaces/ISignage';

interface ISignageListWithTaken extends ISignageList {
    taken: boolean;
}

export default defineComponent({
    name: 'SignageListAssignmentModal',
    data() {
        return {
            availableListsFilter: '',
            selectedListFilter: '',
            selectedLists: [] as ISignageList[]
        };
    },
    computed: {
        availableLists(): ISignageListWithTaken[] {
            if (!this.signageLists) return [];
            
            const alphaOrderedLists = [...this.signageLists].sort((a, b) => 
                (a.name || '').localeCompare(b.name || '')
            );
            return alphaOrderedLists.map((list: ISignageList) => {
                const listWithTaken = { ...list } as ISignageListWithTaken;
                listWithTaken.taken = this.selectedLists.some((selected: ISignageList) => selected.id === list.id);
                return listWithTaken;
            });
        },
        
        filteredAvailableLists(): ISignageListWithTaken[] {
            if (this.availableListsFilter) {
                const filter = this.availableListsFilter.toLowerCase();
                return this.availableLists.filter((list: ISignageListWithTaken) => 
                    list.name.toLowerCase().includes(filter)
                );
            }
            return this.availableLists;
        },
        
        filteredSelectedList(): ISignageList[] {
            if (this.selectedListFilter) {
                const filter = this.selectedListFilter.toLowerCase();
                return this.selectedLists.filter((list: ISignageList) => 
                    list.name.toLowerCase().includes(filter)
                );
            }
            return this.selectedLists;
        }
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        layoutName: {
            type: String,
            default: ''
        },
        signageLists: {
            type: Array as () => ISignageList[],
            default: () => []
        },
        currentlyAssignedListIds: {
            type: Array as () => string[],
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    emits: ['modal-closed', 'list-saved'],
    watch: {
        visible(newVal) {
            if (newVal) {
                this.selectedLists = this.signageLists.filter((list: ISignageList) => 
                    list.id && this.currentlyAssignedListIds.includes(list.id)
                );
                this.availableListsFilter = '';
                this.selectedListFilter = '';
            }
        }
    },
    methods: {
        listPoolClick(list: ISignageListWithTaken) {
            const index = this.selectedLists.findIndex((selected: ISignageList) => selected.id === list.id);
            if (index > -1) {
                this.selectedLists.splice(index, 1);
            } else {
                this.selectedLists.push(list);
            }
        },
        
        selectedListClickHandler(list: ISignageList) {
            const index = this.selectedLists.findIndex((selected: ISignageList) => selected.id === list.id);
            if (index > -1) {
                this.selectedLists.splice(index, 1);
            }
        },
        
        handleClose() {
            this.$emit('modal-closed');
        },
        
        onSave() {
            this.$emit('list-saved', this.selectedLists);
        }
    }
});
